"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16TrashLine = function Svg16TrashLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 1 1 0 2h-.5c0 .041-.001.083-.004.125l-.455 7.276c-.006.105-.017.28-.04.441-.028.2-.094.534-.295.89a2.5 2.5 0 0 1-1.083 1.016 2.502 2.502 0 0 1-.905.24c-.163.012-.338.012-.443.012h-4.55c-.105 0-.28 0-.443-.013a2.503 2.503 0 0 1-.905-.239 2.5 2.5 0 0 1-1.083-1.017 2.503 2.503 0 0 1-.295-.889 5.691 5.691 0 0 1-.04-.441l-.455-7.276A2.003 2.003 0 0 1 6.5 9H6a1 1 0 0 1 0-2h3V6zm-.5 3l.453 7.25c.017.264.025.396.082.496a.5.5 0 0 0 .216.204c.104.05.236.05.5.05h4.497c.265 0 .397 0 .5-.05a.5.5 0 0 0 .217-.204c.057-.1.065-.232.082-.496L15.5 9h-7z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16TrashLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16TrashLine;
exports.default = _default;